import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import {
  ClientCalllogDto,
  ClientDetailDto,
  ClientDto,
  ClientLocationDto,
  ClientPurchasedPackageDetailDto,
  ClientPurchasedPackageDto,
  ClientKpiDto,
} from "./type";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import { getSaga } from "src/request/get";
import { putSaga } from "src/request/put";
import { deleteSaga } from "src/request/delete";
import { postSaga } from "src/request/post";

/**************ACCOUNTSS ********************V*/
export const sendPasswordResetEmail = createAction(
  "SEND_PASSWORD_RESET_MAIL_TO_ACCOUNT",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/clients/admin/send-reset-email",
  })
);

export const sendValidationEmail = createAction(
  "SEND_VALIDATION_MAIL_TO_ACCOUNT",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/clients/admin/send-vadation-email",
  })
);
export const getClients = createAction(
  "GET_ACCOUNTS",
  ({ payload, params }: SagaActionParams<ClientDto[]>) => ({
    payload,
    url: "/api/admin/clients" + (params ? params : ""),
  })
);
export const assignClientPackage = createAction(
  "ASSIGN_CLIENT_PACKAGE",
  ({ payload, body }: SagaActionParams<ClientPurchasedPackageDetailDto>) => ({
    payload,
    body,
    url: "/api/admin/clientpurchasedpackage/assign",
  })
);
export const createClient = createAction(
  "CREATE_ACCOUNT",
  ({ payload, body }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    body,
    url: "/api/admin/clients",
  })
);
export const updateClient = createAction(
  "UPDATE_ACCOUNT",
  ({ payload, body, id }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    body,
    url: "/api/admin/clients/" + id,
  })
);
export const getClientDetails = createAction(
  "GET_ACCOUNT_DETAILS",
  ({ payload, id }: SagaActionParams<ClientDetailDto>) => ({
    payload,
    url: "/api/admin/clients/" + id,
  })
);
/** Tüm müşterilerin KPI'ları — liste ekranındaki kolonlar için. */
export const getClientKpis = createAction("GET_CLIENT_KPIS", ({ payload }: SagaActionParams<ClientKpiDto[]>) => ({
  payload,
  url: "/api/admin/clients/kpi",
}));

/** Tek müşterinin KPI'ı — detay sayfasındaki kartlar için. */
export const getClientKpi = createAction("GET_CLIENT_KPI", ({ payload, id }: SagaActionParams<ClientKpiDto>) => ({
  payload,
  url: "/api/admin/clients/kpi/" + id,
}));

export const getClientCallogByClientId = createAction(
  "GET_ACCOUNT_CALLOGS",
  ({ payload, id }: SagaActionParams<ClientCalllogDto[]>) => ({
    payload,
    url: "/api/admin/adminclientcalllogs/get-by-client-id/" + id,
  })
);
/**************CALLOGS ********************V*/
export const getClientCallogs = createAction(
  "GET_ACCOUNT_CALLOGS",
  ({ payload }: SagaActionParams<ClientCalllogDto[]>) => ({
    payload,
    url: "/api/admin/adminclientcalllogs",
  })
);
export const getClientCallogDetail = createAction(
  "GET_DETAIL_ACCOUNT_CALLOGS",
  ({ payload, id }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogs/" + id,
  })
);
export const createClientCallogs = createAction(
  "CREATE_ACCOUNT_CALLOGS",
  ({ payload, body }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    body,
    url: "/api/admin/adminclientcalllogs",
  })
);

export const updateClientCallogs = createAction(
  "UPDATE_ACCOUNT_CALLOGS",
  ({ payload, id, body }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    body,
    url: "/api/admin/adminclientcalllogs/" + id,
  })
);

export const deleteClientCallogs = createAction(
  "DELETE_ACCOUNT_CALLOGS",
  ({ payload, id }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    url: "/api/admin/adminclientcalllogs/" + id,
  })
);

/**************PURCHASED PACKAGE ********************V*/
export const getClientPurchasedPackageList = createAction(
  "GET_ACCOUNT_PURCHASED_PACKAGES",
  ({ payload, id }: SagaActionParams<ClientPurchasedPackageDto[]>) => ({
    payload,
    url: "/api/admin/clientpurchasedpackage/" + id,
  })
);
export const getClientPurchasedPackageDetail = createAction(
  "GET_ACCOUNT_PURCHASED_PACKAGE_DETAIL",
  ({ payload, id }: SagaActionParams<ClientPurchasedPackageDetailDto>) => ({
    payload,
    url: "/api/admin/clientpurchasedpackage/detail/" + id,
  })
);
export const createPurchasedPackageForClient = createAction(
  "CREATE_PURCHASED_PACKAGE",
  ({ payload, body }: SagaActionParams<ClientPurchasedPackageDto>) => ({
    payload,
    body,
    url: "/api/admin/clientpurchasedpackage",
  })
);
export const deleteClientPurchasedPackage = createAction(
  "DELETE_ACCOUNT_PURCHASED_PACKAGE",
  ({ payload, id }: SagaActionParams<ClientPurchasedPackageDetailDto>) => ({
    payload,
    url: "/api/admin/clientpurchasedpackage/" + id,
  })
);
/**************ACCOUNT LOCATION ********************V*/
export const getClientLocations = createAction(
  "GET_ACCOUNT_LOCATIONS",
  ({ payload, id }: SagaActionParams<ClientLocationDto[]>) => ({
    payload,
    url: "/api/admin/adminclientlocations/get/" + id,
  })
);
export const getClientLocationDetail = createAction(
  "GET_ACCOUNT_LOCATION_DETAIL",
  ({ payload, id }: SagaActionParams<ClientLocationDto>) => ({
    payload,
    url: "/api/admin/adminclientlocations/" + id,
  })
);
export const createClientLocation = createAction(
  "CREATE_ACCOUNT_LOCATION",
  ({ payload, body }: SagaActionParams<ClientLocationDto>) => ({
    payload,
    body,
    url: "/api/admin/adminclientlocations",
  })
);

export const updateClientLocation = createAction(
  "UPDATE_ACCOUNT_LOCATION",
  ({ payload, id, body }: SagaActionParams<ClientLocationDto>) => ({
    payload,
    body,
    url: "/api/admin/adminclientlocations/" + id,
  })
);

export const deleteClientLocation = createAction(
  "DELETE_ACCOUNT_LOCATION",
  ({ payload, id }: SagaActionParams<ClientCalllogDto>) => ({
    payload,
    url: "/api/admin/adminclientlocations/" + id,
  })
);
//PURCHASEDPACKAGE

const clientSaga = [
  /**************PURCHASED PACKAGE ********************V*/
  takeLatest<any>(
    getClientPurchasedPackageDetail.toString(),
    (payload: SagaGenericParams<ClientPurchasedPackageDetailDto>) =>
      getSaga<ClientPurchasedPackageDetailDto>(payload)
  ),
  takeLatest<any>(
    getClientPurchasedPackageList.toString(),
    (payload: SagaGenericParams<ClientPurchasedPackageDto[]>) =>
      getSaga<ClientPurchasedPackageDto[]>(payload)
  ),
  takeLatest<any>(
    createPurchasedPackageForClient.toString(),
    (payload: SagaGenericParams<ClientPurchasedPackageDto>) =>
      postSaga<ClientPurchasedPackageDto>(payload)
  ),
  takeLatest<any>(
    deleteClientPurchasedPackage.toString(),
    (payload: SagaGenericParams<ClientPurchasedPackageDto>) =>
      deleteSaga<ClientPurchasedPackageDto>(payload)
  ),
  /**************ACCOUNTSS *********************/

  takeLatest<any>(
    createClient.toString(),
    (payload: SagaGenericParams<ClientDetailDto>) =>
      postSaga<ClientDetailDto>(payload)
  ),
  takeLatest<any>(
    assignClientPackage.toString(),
    (payload: SagaGenericParams<ClientPurchasedPackageDetailDto>) =>
      postSaga<ClientPurchasedPackageDetailDto>(payload)
  ),

  takeLatest<any>(
    updateClient.toString(),
    (payload: SagaGenericParams<ClientDetailDto>) =>
      putSaga<ClientDetailDto>(payload)
  ),
  takeLatest<any>(
    sendPasswordResetEmail.toString(),
    (payload: SagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest<any>(
    sendValidationEmail.toString(),
    (payload: SagaGenericParams<any>) => postSaga<any>(payload)
  ),
  takeLatest<any>(
    getClients.toString(),
    (payload: SagaGenericParams<ClientDto[]>) => getSaga<ClientDto[]>(payload)
  ),
  takeLatest<any>(
    getClientDetails.toString(),
    (payload: SagaGenericParams<ClientDetailDto>) =>
      getSaga<ClientDetailDto>(payload)
  ),
  takeLatest<any>(
    getClientCallogByClientId.toString(),
    (payload: SagaGenericParams<ClientCalllogDto[]>) =>
      getSaga<ClientCalllogDto[]>(payload)
  ),
  /**************CALLOGS ********************V*/
  takeLatest<any>(
    getClientCallogs.toString(),
    (payload: SagaGenericParams<ClientCalllogDto[]>) =>
      getSaga<ClientCalllogDto[]>(payload)
  ),
  takeLatest<any>(
    getClientCallogDetail.toString(),
    (payload: SagaGenericParams<ClientCalllogDto>) =>
      getSaga<ClientCalllogDto>(payload)
  ),
  takeLatest<any>(
    createClientCallogs.toString(),
    (payload: SagaGenericParams<ClientCalllogDto>) =>
      postSaga<ClientCalllogDto>(payload)
  ),
  takeLatest<any>(
    updateClientCallogs.toString(),
    (payload: SagaGenericParams<ClientCalllogDto>) =>
      putSaga<ClientCalllogDto>(payload)
  ),
  takeLatest<any>(
    deleteClientCallogs.toString(),
    (payload: SagaGenericParams<ClientCalllogDto>) =>
      deleteSaga<ClientCalllogDto>(payload)
  ),

  /**************CALLOGS ********************V*/
  takeLatest<any>(
    getClientLocations.toString(),
    (payload: SagaGenericParams<ClientLocationDto[]>) =>
      getSaga<ClientLocationDto[]>(payload)
  ),
  takeLatest<any>(
    getClientLocationDetail.toString(),
    (payload: SagaGenericParams<ClientLocationDto>) =>
      getSaga<ClientLocationDto>(payload)
  ),
  takeLatest<any>(
    createClientLocation.toString(),
    (payload: SagaGenericParams<ClientLocationDto>) =>
      postSaga<ClientLocationDto>(payload)
  ),
  takeLatest<any>(
    updateClientLocation.toString(),
    (payload: SagaGenericParams<ClientLocationDto>) =>
      putSaga<ClientLocationDto>(payload)
  ),
  takeLatest<any>(
    deleteClientLocation.toString(),
    (payload: SagaGenericParams<ClientLocationDto>) =>
      deleteSaga<ClientLocationDto>(payload)
  ),
  takeLatest<any>(getClientKpis.toString(), (payload: SagaGenericParams<ClientKpiDto[]>) =>
    getSaga<ClientKpiDto[]>(payload)
  ),
  takeLatest<any>(getClientKpi.toString(), (payload: SagaGenericParams<ClientKpiDto>) =>
    getSaga<ClientKpiDto>(payload)
  ),
];

export default clientSaga;
